import { Component, OnInit } from '@angular/core';
import {kycupload,UserService} from "../services/user.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import {NotificationsService} from "angular2-notifications";
import {KycserviceService} from "../services/kycservice.service";
import { environment } from "../../environments/environment";

@Component({
  selector: 'app-manualkyc',
  templateUrl: './manualkyc.component.html',
  styleUrls: ['./manualkyc.component.css']
})
export class ManualkycComponent implements OnInit {
  
  S3_BUCKET_URL = environment.S3_BUCKET_URL;
  customerid = '';
  permission : String;
  serach: any;
  kyc:any = {};
  actionKycListPerformed: Boolean;
  actionKycupload: Boolean;
  userdet:any;
  formkyc: kycupload = {
    _csrf:  '',
    front: '',
    back: '',
    board_member_id:'',
    pan: '',
    company_reg: '',
    authflag: false,
    aoa:'',
    bank_accn:'',
    video_selfie:'',
    source_funds:'',
    appln_questionnaire:'',
    addn_infor:'',
    letter_of_auth:'',
    userid:''
};
frontPlace:any;
placeHold:any;
submit:boolean=false;
currentAvatar:any;
fileToUpload:File = null;
kycdet:any = {};
kycstatus:String=''
user:any;

  constructor(private userService: UserService,
    private KycserviceService: KycserviceService,
    private router: Router,
    private route: ActivatedRoute,
    private  notifSer: NotificationsService,
    private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    // check user is logged or not
    if (!this.userService.isLoggedIn()) {
      this.router.navigateByUrl('/index');
  } else {

    this.placeHold ={
        front:'',
        back: '',
        company_reg: '',
        board_member_id: '',
        aoa:'',
        bank_accn:'',
        video_selfie:'',
        source_funds:'',
        appln_questionnaire:'',
        letter_of_auth:'',
        // addn_infor:'',
        error:{
          front:'',
          back:'',
          company_reg:'',
          board_member_id:'',
          aoa:'',
          bank_accn:'',
          video_selfie:'',
          source_funds:'',
          appln_questionnaire:'',
          letter_of_auth:''
          // addn_infor:''
        }
      }
      
      if(typeof localStorage.getItem('adminmenus') != 'undefined' && localStorage.getItem('adminmenus').length>0)
      {
          var spt = this.router.url.split("/");
          var menu_url = spt[1];
          var adminmenus = JSON.parse(localStorage.getItem('adminmenus'));
          var adminrules = JSON.parse(localStorage.getItem('adminrules'));
          var index = adminmenus.findIndex(x => (x.menu_url) === menu_url);
          
          if(index!=-1)
          {
              var menuid = adminmenus[index]._id;
              var adindex = adminrules.findIndex(x => (x.menu_id) === menuid.toString());
              this.permission = (adindex!=-1)?adminrules[adindex].permission:"write";
          }

      }
      this.customerid = this.route.snapshot.paramMap.get('id');
      this.getKycDetails();
      if (typeof this.customerid != 'undefined' && this.customerid) {
          if (this.customerid) {
           
            
             this.getkyc();
            
          }
      } else {
          this.router.navigateByUrl('customer');

      }

  }
  }

  getkyc()
  {
    setTimeout (() => {
      //this.get_user_details();
      this.placeHold.front = '';
      //this.placeHold.back = 'Choose File';
      this.placeHold.company_reg = '';
      this.placeHold.board_member_id = '';
      this.placeHold.aoa= '';
      this.placeHold.bank_accn = '';
      //this.placeHold.video_selfie = 'Choose File';
      this.placeHold.source_funds = '';
      this.placeHold.appln_questionnaire = '';
      this.placeHold.letter_of_auth = '';
      // this.placeHold.addn_infor = 'Choose File';
       
          this.KycserviceService.getkycbyadmin(this.customerid).subscribe(res =>{
            console.log("kyc data====",res);
            this.formkyc = res;
            this.kycstatus = res.status;
            console.log("kycstatus====",this.kycstatus);
            var url = this.S3_BUCKET_URL;
            this.placeHold.front = res.front =='' ? '' : res.front.replace(url, "");
          //this.placeHold.back = res.back == '' ? 'Choose File' : res.back.replace(url, "");
          this.placeHold.company_reg = res.company_reg == '' ? '' : res.company_reg.replace(url, "");
          this.placeHold.board_member_id = res.board_member_id == '' ? '' : res.board_member_id.replace(url, "");
          this.placeHold.aoa= res.aoa == '' ? '' : res.aoa.replace(url, "");
          this.placeHold.bank_accn = res.bank_accn == '' ? '' : res.bank_accn.replace(url, "");
          //this.placeHold.video_selfie = res.video_selfie == '' ? 'Choose File' : res.video_selfie.replace(url, "");
          this.placeHold.source_funds = res.source_funds == '' ? '' : res.source_funds.replace(url, "");
          this.placeHold.appln_questionnaire = res.appln_questionnaire == '' ? '' : res.appln_questionnaire.replace(url, "");
          this.placeHold.addn_infor = res.addn_infor == '' ? '' : res.addn_infor.replace(url, "");
          this.placeHold.letter_of_auth = res.letter_of_auth == '' ? '' : res.letter_of_auth.replace(url, "");
          if (res.status=='Pending') {
              //this.router.navigate(['kyc/'+this.customerid]);
          }
          },(err)=>{
          })
      console.log("kyc this.user====",this.user);
     
   }, 200);
  }

  getKycDetails() {
    this.spinnerService.show();
    this.KycserviceService.getuserkyc(this.customerid).subscribe(list => {
        console.log(list,"list====");
        if (list.status) {
            // if(list.kyc == true)
            // {
            //     this.actionKycListPerformed = true;
            //     this.kyc = list.kyclist[0]

            // }
            // else
            // {
                this.actionKycupload = true;
                this.userdet = list.userdetail;

           // }
            
            console.log('this.kyc/this.kyc',this.kyc);
            
        }
        // this.totalRecords = list.total;
        this.spinnerService.hide();
    }, (err) => {
        this.spinnerService.hide();
        this.notifSer.error(
            'Error',
            err.error.message,
            {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
            }
        )
        
    })
}

public onChange(files,key): void {    
    var path = files[0].type;    
    console.log('path',path);
    console.log('size of the file',files[0].size);
      var filezsize:any = '';
      var maxdocsize:any = '';
      var maxvidsize:any = '';
    if(path == 'image/jpeg'){
       filezsize = files[0].size / 1000;
       maxdocsize = '200.00' //kb
    }
    if(path == 'video/mp4'){
      filezsize = files[0].size / 1e+6;
      maxvidsize = 3; //mb
   }
    // if (path == "video/*" || path=="video/mp4" || path == "image/jpg" || path == "image/jpeg" || path == "application/pdf") {
    this.fileToUpload = files.item(0);  
    if(filezsize > maxdocsize && path == 'image/jpeg'){
      this.notifSer.error(
        'Error',
        "Image size limit exceeded",
        {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50
        }
    )
      return;
    }
    if(filezsize > maxvidsize && path == 'video/mp4'){

      this.notifSer.error(
        'Error',
        "Video size limit exceeded",
        {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50
        }
    )
      return;
    }
    if(key == 'front' && path !== "image/jpeg" ){
      if(path !== "application/pdf"){
        this.notifSer.error(
            'Error',
            "Only Upload jpeg Image Format Or PDF Format",
            {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
            }
        )
        return;
      }
    }
    if(key == 'back' &&  path !== "image/jpeg" ){
      if(path !== "application/pdf"){
        this.notifSer.error(
            'Error',
            "Only Upload jpeg Image Format Or PDF Format",
            {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
            }
        )
        return;
      }
    }
    if(key == 'company_reg' && path !== "image/jpeg"){
      if(path !== "application/pdf"){
        this.notifSer.error(
            'Error',
            "Only Upload jpeg Image Format Or PDF Format",
            {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
            }
        )
        return;
      }
    }
    if(key == 'board_member_id' && path !== "image/jpeg"){
      if(path !== "application/pdf"){
        this.notifSer.error(
            'Error',
            "Only Upload jpeg Image Format Or PDF Format",
            {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
            }
        )
        return;
      }
    }
    if(key == 'aoa' && path !== "image/jpeg"){
      if(path !== "application/pdf"){
        this.notifSer.error(
            'Error',
            "Only Upload jpeg Image Format Or PDF Format",
            {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
            }
        )
        return;
      }
    }
    if(key == 'bank_accn' && path !== "image/jpeg"){
      if(path !== "application/pdf"){
        this.notifSer.error(
            'Error',
            "Only Upload jpeg Image Format Or PDF Format",
            {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
            }
        )
        return;
      }
    }
    if(key == 'video_selfie' && path!=="video/mp4"){
      this.notifSer.error(
        'Error',
        "Only Upload Video File",
        {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50
        }
    )
      return;
    }
    if(key == 'source_funds' && path!=="image/jpeg" ){
      if(path !== "application/pdf"){
        this.notifSer.error(
            'Error',
            "Only Upload jpeg Image Format Or PDF Format",
            {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
            }
        )
        return;
      }
    }
    if(key == 'appln_questionnaire' && path !=='application/pdf'){
      if(path !== "image/jpeg"){
        this.notifSer.error(
            'Error',
            "Only Upload jpeg Image Format Or PDF Format",
            {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
            }
        )
        return;
      }
    }

    if(key == 'letter_of_auth' && path !=='application/pdf'){
      if(path !== "image/jpeg"){
        this.notifSer.error(
            'Error',
            "Only Upload jpeg Image Format Or PDF Format",
            {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
            }
        )
        return;
      }
    }
    this.userService.csrf().subscribe((response) => {
    this.userService.uploadDocn(this.fileToUpload,key,response._csrf).subscribe(data => {
      var result = data.result.secure_url;
      if(key == 'front'){
        this.formkyc['front'] = result;
        this.placeHold.front = this.fileToUpload.name
      }
      // if(key == 'back'){
      //   this.formkyc['back'] = result;
      //   this.placeHold.back = this.fileToUpload.name;
      // }
      if(key == 'company_reg'){
        this.formkyc['company_reg'] = result;
        this.placeHold.company_reg = this.fileToUpload.name;
      }
      if(key == 'board_member_id'){
        this.formkyc['board_member_id'] = result;
        this.placeHold.board_member_id = this.fileToUpload.name;
      }
      if(key == 'aoa'){
        this.formkyc['aoa'] = result;
        this.placeHold.aoa = this.fileToUpload.name;
      }
      if(key == 'bank_accn'){
        this.formkyc['bank_accn'] = result;
        this.placeHold.bank_accn = this.fileToUpload.name;
      }
      if(key == 'video_selfie'){
        this.formkyc['video_selfie'] = result;
        this.placeHold.video_selfie = this.fileToUpload.name;
      }
      if(key == 'source_funds'){
        this.formkyc['source_funds'] = result;
        this.placeHold.source_funds = this.fileToUpload.name;
      }
      if(key == 'appln_questionnaire'){
        this.formkyc['appln_questionnaire'] = result;
        this.placeHold.appln_questionnaire = this.fileToUpload.name;
      }
      if(key == 'addn_infor'){
        this.formkyc['addn_infor'] = result;
        this.placeHold.addn_infor = this.fileToUpload.name;
      }
      if(key == 'letter_of_auth'){
        this.formkyc['letter_of_auth'] = result;
        this.placeHold.letter_of_auth = this.fileToUpload.name;
      }
      this.notifSer.success(
        'Success',
        data.message,
        {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50
        }
    )
    },(err)=>{
        this.notifSer.error(
            'Error',
            err.error.message,
            {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
            }
        )
    })
  })
  }
  csrf() {
    this.userService.csrf().subscribe((response) => {
        this.formkyc._csrf = response._csrf;
    }, (err) => {

    });
}
  kycSave(){    
    this.submit =true; 
    console.log("this.placeHold==",this.placeHold);
    console.log("JSON.stringify(this.placeHold).search('Choose File')",JSON.stringify(this.placeHold).search('Choose File'));
    //return;   
    if(JSON.stringify(this.placeHold).search('Choose File') ==-1){
      console.log("call here===");
      this.userService.csrf().subscribe((response) => {
        this.formkyc._csrf = response._csrf;
        this.formkyc.userid = this.customerid;
      this.userService.kycSave(this.formkyc).subscribe((response) => {
        if (response.status ==200) {
          this.notifSer.success(
            'Success',
            response.message,
            {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
            }
        )
          setTimeout(() => {
            this.router.navigate(['kyc/'+this.customerid]);
          }, 1000)
        }
      }, (err) => {
        this.notifSer.error(
            'Error',
            err.error.message,
            {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
            }
        )
      });
    })
      }
    else{  
      console.log("call there===");    
      if(this.formkyc.front == ''){
        this.placeHold.error.front = 'Front side is required';
      }
      // if(this.formkyc.back == ''){
      //   this.placeHold.error.back = 'Back side is required';
      // }
      if(this.formkyc.pan == ''){
        this.placeHold.error.pan = 'Pan is required';
      }
      if(this.formkyc.company_reg == ''){
        this.placeHold.error.company_reg = 'Selfie with ID Proof is required';
      }
      if(this.formkyc.board_member_id == ''){
        this.placeHold.error.board_member_id = 'Board Member National id Proof is required';
      }
      if(this.formkyc.aoa == ''){
        this.placeHold.error.aoa = 'AOA is required';
      }
      if(this.formkyc.bank_accn == ''){
        this.placeHold.error.bank_accn = 'Bank Account is required';
      }
      // if(this.formkyc.video_selfie == ''){
      //   this.placeHold.error.video_selfie = 'Video Selfie is required';
      // }
      if(this.formkyc.source_funds == ''){
        this.placeHold.error.source_funds = 'Source Funds is required';
      }
      if(this.formkyc.appln_questionnaire == ''){
        this.placeHold.error.appln_questionnaire = 'Application Quesstionnaire is required';
      }

      if(this.formkyc.letter_of_auth == ''){
        this.placeHold.error.letter_of_auth = 'Letter of Authorization is required';
      }
      // if(this.formkyc.addn_infor == ''){
      //   this.placeHold.error.addn_infor = 'Additional Information is required';
      // }
    }
    
  }

  savedraftKyc(){
    this.submit =true;
      if(this.formkyc.company_reg == '' && this.formkyc.board_member_id == '' && this.formkyc.aoa == '' && this.formkyc.bank_accn == '' && this.formkyc.source_funds == '' && this.formkyc.appln_questionnaire == '' && this.formkyc.letter_of_auth == ''){
        this.notifSer.error(
          'Error',
          "Please upload any one proof to save",
          {
              timeOut: 3000,
              showProgressBar: true,
              pauseOnHover: false,
              clickToClose: true,
              maxLength: 50
          }
      )
      }
      else
      {
        this.userService.csrf().subscribe((response) => {
          this.formkyc._csrf = response._csrf;
          this.formkyc.userid = this.customerid;
          console.log("this.formkyc====",this.formkyc);
        this.userService.savedraftKyc(this.formkyc).subscribe((response) => {
          console.log("save draft response====",response);
          if (response.status ==200) {
            this.notifSer.success(
              'Success',
              response.message,
              {
                  timeOut: 3000,
                  showProgressBar: true,
                  pauseOnHover: false,
                  clickToClose: true,
                  maxLength: 50
              }
          )
          this.getkyc();
          }
        }, (err) => {
          this.notifSer.error(
            'Error',
            err.error.message,
            {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
            }
        )
        });
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/manualkyc/manualkyc.component.ts